import { render, staticRenderFns } from "./financerecord.vue?vue&type=template&id=b313347c"
import script from "./financerecord.vue?vue&type=script&lang=js"
export * from "./financerecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports